export default "__VITE_ASSET__f8572b00__"